// extracted by mini-css-extract-plugin
module.exports = {"carousel-indicators":"b2bCarouselMain_carousel-indicators__gy0if","active":"b2bCarouselMain_active__2jhP8"};